import DashboardLockScreen from "./components/DashboardLockScreen";

const DashboardPublicConfig = {
    settings: {
        layout: {
            config: {
                navbar: {
                    display: false,
                },
                toolbar: {
                    display: false,
                },
                footer: {
                    display: false,
                },
                leftSidePanel: {
                    display: false,
                },
                rightSidePanel: {
                    display: false,
                },
            },
        },
    },
    routes: [
        {
            path: 'dashboard/screen',
            element: <DashboardLockScreen />
        }
    ],
};

export default DashboardPublicConfig;